import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  wrapper: {
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: theme.spacings.lg,
    padding: theme.spacings.xl,
    width: '66.66%',
    shadowColor: theme.colors.black,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.15,
    shadowRadius: 4,
    elevation: 3,
  },
  leftCol: {
    width: '50%',
    rowGap: theme.spacings.sm,
  },
  appRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  appIcon: {
    width: 70,
    height: 70,
    marginLeft: -8,
  },
  appTitle: {
    fontWeight: 'bold',
    fontSize: theme.fontSizes.xl,
  },
  featureText: {
    fontSize: theme.fontSizes.xl,
  },
  rightCol: {
    width: '50%',
    rowGap: theme.spacings.md,
  },
  buyButton: {
    backgroundColor: theme.colors.primary,
    paddingVertical: theme.spacings.sm,
    paddingHorizontal: theme.spacings.md,
    borderRadius: theme.borderRadii.md,
  },
  buyButtonRow: {
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: theme.spacings.md,
    fontSize: theme.fontSizes.xl,
  },
  buyButtonText: {
    color: theme.colors.white,
    fontWeight: 'bold',
  },
  boldText: {
    fontWeight: 'bold',
  },
  digaLink: {
    color: theme.colors.link,
  },
  footer: {
    rowGap: theme.spacings.sm,
    marginTop: theme.spacings.xl,
    alignItems: 'center',
  },
});
